export const LONG_TERM_CARE_DATA_REQUEST = 'LONG_TERM_CARE_DATA_REQUEST';
export const LONG_TERM_CARE_DATA_SUCCESS = 'LONG_TERM_CARE_DATA_SUCCESS';
export const LONG_TERM_CARE_DATA_FAIL = 'LONG_TERM_CARE_DATA_FAIL';
